import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';
import { HelpCircle } from 'lucide-react';

const FAQ = () => {
  const faqs = [
    {
      question: 'Vocês fazem lançamento de cursos online?',
      answer: 'Sim. Nosso ecossistema nos permite atuar desde a concepção do curso passando por gravação, roteiros, sites, vídeos de vendas até lives de lançamento e campanhas de tráfego pago. Entre em contato e conheça nosso portfólio. Vamos desenvolver a melhor estratégia para seu lançamento. 😉🍀',
    },
    {
      question: 'Vocês alugam o estúdio para gravação de vídeos?',
      answer: 'Sim. Nosso estúdio conta com espaço tratado acusticamente onde é possível gravar áudio com qualidade a qualquer hora do dia no centro de Brasília. Temos várias opções de cenários e fundos diferentes incluindo opções de fundo infinito. Nosso espaço é confortável e pensado para estimular a criatividade e inspiração.',
    },
    {
      question: 'Como funciona a gravação de Podcasts?',
      answer: 'Temos várias opções de cenário e configurações diferentes para diferentes estilos de podcasts (videocast) desde a mesa tradicional até poltronas e sofás mais descontraídos. Você pode trazer objetos para personalizar seu cenário.',
    },
    {
      question: 'Como é o processo para gravar uma música no estúdio?',
      answer: 'O primeiro passo é arranjar a música. Definir a métrica, em qual parte voltar, onde haverá solos e, por fim, quais instrumentos farão parte do projeto e como eles deverão tocar. Para isso, sugerimos o serviço de PRODUÇÃO E DIREÇÃO MUSICAL. Nele, vamos transformar a sua ideia em música.\n\nGravamos uma guia, estruturamos a métrica, definimos os instrumentos e depois contratamos os músicos para a execução do projeto. Depois mixamos, masterizamos e entregamos sua música no mais alto padrão de qualidade exigido pelo mercado.\n\nSe você, porém, já possui a estrutura da música pronta e os músicos para a execução do projeto, oferecemos o serviço de GRAVAÇÃO E PRODUÇÃO DA SUA BANDA. Neste caso, agendamos horários e vamos gravando tudo até chegar no momento da MIX, MASTER E FINALIZAÇÃO.\n\nEsses três processos garantirão que os instrumentos estejam corretamente dispostos na música, seus volumes e timbres alinhados e, a música, pronta para tocar em qualquer lugar, de um celular a uma grande casa de shows.\n\nEntre em contato para saber mais.',
    },
    {
      question: 'O que eu preciso para gravar um clipe?',
      answer: 'Depende do que você quer!\n\nVocê pode fazer um clipe em estúdio ou externo. Em todo caso você precisa definir um roteiro e buscar algumas referências para nos mostrar.\n\nNão existe "melhor" ou "pior".\n\nFazendo ao vivo você capta a "vibe" do momento. Interessante para quem gosta de improvisar. Porém o visual fica mais restrito. Haverá cabos, fones de ouvido, amplificadores e etc… O video fica restrito aos ângulos possíveis na disposição da banda.\n\nFazendo o audio primeiro e depois dublando o video temos maior qualidade no audio no sentido de poder voltar e rever cada trecho em específico. O video pode também ser mais detalhado pois não haverá preocupação em "entrar" na imagem de outras câmeras e nem haverá necessidade de cabos e fones. Porém a "vibe" é outra e não adianta tentar convencer o expectador de que não se está dublando.\n\nO importante é saber: Não existe melhor ou pior. É necessário detectar o objetivo do projeto e direcionar a produção para o melhor caminho.\n\nSe você prefere um clipe externo, todavia, precisamos ponderar algumas variáveis: a ideia que você possui para o clipe, o orçamento disponível para investimento na sua produção, se haverá PRODUÇÃO, ROTEIRO, DIREÇÃO ou se será somente CAPTAÇÃO de imagens exteriores. Um clipe externo pode ser barato ou muito caro, a depender do que será gravado.\n\nA melhor forma de avaliarmos o que você precisa para concretizar seu clipe é marcarmos uma reunião. Nela, poderemos ouvir a sua música, entender melhor a sua ideia e agregar nossa experiência profissional para transformá-la em realidade.\n\nVamos tomar um café? Marque uma reunião para discutirmos suas ideias ou venha conhecer o nosso espaço.',
    },
    {
      question: 'Como é o processo de trabalho de vocês?',
      answer: 'Nosso processo é rápido, simples e descomplicado. Começamos nossa conversa pelo Whatsapp, trocamos links, imagens, e referências sobre o seu projeto e suas expectativas e, com base nisso, elaboramos um orçamento adequado às suas necessidades. Mande um whatsapp agora mesmo e vamos transformar suas ideias em audiovisual que converte.',
    },
    {
      question: 'Quanto custa um serviço de áudio e vídeo completo?',
      answer: 'Acreditamos que cada projeto é único e merece uma atenção especial. Entre em contato pelo whatsapp e conte mais sobre suas ideias. Fique livre para dar exemplos, referências e links que possam nos ajudar a entender sua demanda e agilizar nossa resposta.',
    },
    {
      question: 'E se eu quiser gravar mais músicas? Como eu faço?',
      answer: 'Fazemos descontos para clientes que contratam uma quantidade maior de produtos! Podemos montar pacotes personalizados, de acordo com a necessidade de cada artista.\n\nEntre em contato para agendarmos uma reunião e discutirmos as suas necessidades.',
    },
    {
      question: 'Em quanto tempo meu material fica pronto?',
      answer: 'Rápido! Buscamos sempre estabelecer prazos de entrega alinhados às necessidades de cada cliente.\n\nVamos marcar uma reunião para você conhecer melhor o estúdio?',
    },
    {
      question: 'Qual a forma de pagamento?',
      answer: 'Aceitamos cartões de crédito, débito e também emitimos boleto bancário.\n\nParcelamos SIM. Depende do valor e do projeto. Estamos sempre abertos a negociações.',
    },
    {
      question: 'Vocês gravam áudio e vídeo de eventos e palestras?',
      answer: 'Sim. Gravamos todo tipo de eventos com equipe completa de audio e video.',
    },
    {
      question: 'Vocês gravam Cursos Online (EAD)?',
      answer: 'Sim. Temos estúdio tratato acusticamente com fundos infinitos (branco, preto e verde) e também fazemos gravações em ambientes externos como salas de aula e eventos.',
    },
  ];

  return (
    <section id="faq" className="py-16 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12 space-y-4">
          <div className="inline-block">
            <span className="text-[#ff6b35] font-semibold text-sm uppercase tracking-wider bg-[#ff6b35]/10 px-4 py-2 rounded-full">
              Perguntas Frequentes
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-[#1e3a5f]">
            Dúvidas? <span className="text-[#ff6b35]">Estamos aqui!</span>
          </h2>
          <p className="text-xl text-gray-600">
            Confira as respostas para as perguntas mais comuns
          </p>
        </div>

        {/* FAQ Accordion */}
        <Accordion type="single" collapsible className="space-y-4">
          {faqs.map((faq, index) => (
            <AccordionItem
              key={index}
              value={`item-${index}`}
              className="bg-gray-50 rounded-xl px-6 border-2 border-transparent hover:border-[#ff6b35]/20 transition-all duration-300"
            >
              <AccordionTrigger className="text-left font-semibold text-[#1e3a5f] hover:text-[#ff6b35] transition-colors py-6">
                <div className="flex items-start space-x-3">
                  <HelpCircle className="text-[#ff6b35] flex-shrink-0 mt-1" size={20} />
                  <span>{faq.question}</span>
                </div>
              </AccordionTrigger>
              <AccordionContent className="text-gray-600 leading-relaxed pb-6 pl-8 whitespace-pre-line">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>

        {/* CTA */}
        <div className="text-center mt-12 p-8 bg-gradient-to-r from-[#1e3a5f] to-[#48a9a6] rounded-2xl text-white">
          <h3 className="text-2xl font-bold mb-4">Não encontrou o que procura?</h3>
          <p className="mb-6 text-white/90">Entre em contato conosco e tire todas as suas dúvidas!</p>
          <button
            onClick={() => window.open('https://wa.me/5561985533770', '_blank')}
            className="inline-flex items-center px-8 py-4 bg-white text-[#1e3a5f] font-semibold rounded-full shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300"
          >
            Falar com Especialista
          </button>
        </div>
      </div>
    </section>
  );
};

export default FAQ;